import { render, staticRenderFns } from "./CorridaDaBiblia.vue?vue&type=template&id=3280e9ea&scoped=true"
import script from "./CorridaDaBiblia.vue?vue&type=script&lang=js"
export * from "./CorridaDaBiblia.vue?vue&type=script&lang=js"
import style0 from "./CorridaDaBiblia.vue?vue&type=style&index=0&id=3280e9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3280e9ea",
  null
  
)

export default component.exports